module.exports = __webpack_public_path__ + "static/canisterGrey-04c7d4c48e85aa1471ba05e50bd6c13c.jpg";